import axios from './index'

class common {
    // static getMenuTree(params) {
    //     return axios.get(`/back_oauth/menu/tree/user`,params)
    // }

    static login(params) {
        //return axios.post(`/app-admin/user/login`,params)
        return axios.post(`/app-admin/sys/user/login`,params)
    }
    
    // //获取用户信息
    // static getUserInfo(params) {
    //     return axios.get(`/back_oauth/user/info`,params)
    // }

    // //退出
    // static loginOut(params) {
    //     return axios.post(`/back_oauth/user/sign_out`,params)
    // }


    //站点名称搜索
    static station(params) {
        return axios.get(`/app-trains/station/search`,{params:params})
    }
    
    //上传图片
    static upload(params) {
        return axios.post(`/upload/file/uploads`,params)
    }
}

export default common;
